module.exports = __webpack_public_path__ + "static/media/recortes_home_04.58f9f1e8.jpg";